<template>
    <div>
        <p style="font-size: 0.4rem">
            {{ groupInfo.name }}
            <el-tooltip effect="dark" content="绑定企业微信聊天群" placement="top">
                <el-button type="primary" size="mini" style="float: right" @click="execBind(groupInfo.chat_id)">绑定</el-button>
            </el-tooltip>
        </p>
        <p style="margin-top: 0.2rem; color: grey; font-size: 0.26rem">
            群主：{{ groupInfo.boss }} | 创建时间：{{ groupInfo.create_time }}
        </p>
        <p style="margin-top: 0.2rem; color: grey; font-size: 0.26rem">
            <el-collapse v-if="groupInfo.notice">
                <el-collapse-item title="群公告">
                    <p style="white-space: pre-wrap">{{ groupInfo.notice }}</p>
                </el-collapse-item>
            </el-collapse>
            <span v-else>群公告：未设置</span>
        </p>
        <el-table :data="groupInfo.members" size="mini" border style="width: 100%; margin-top: 0.2rem" v-cloak>
            <el-table-column label="群成员">
                <template slot-scope="scope">
                    <el-tooltip :content="scope.row.name" placement="top" :open-delay="500">
                        <span class="hide-style">{{ scope.row.name
                        }}<span style="color: #2db34a" v-if="scope.row.member_type === 2">
                                @微信</span></span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="群昵称">
                <template slot-scope="scope">
                    <el-tooltip :content="scope.row.group_nickname
                        ? scope.row.group_nickname
                        : scope.row.name
                        " placement="top" :open-delay="500">
                        <span class="hide-style">{{
                            scope.row.group_nickname
                            ? scope.row.group_nickname
                            : scope.row.name
                        }}</span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="进群时间">
                <template slot-scope="scope">
                    <el-tooltip :content="scope.row.join_time" placement="top" :open-delay="500">
                        <span class="hide-style">{{ scope.row.join_time }}</span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="进群方式">
                <template slot-scope="scope">
                    <el-tooltip :content="getJoinType(scope.row)" placement="top" :open-delay="500">
                        <span class="hide-style">{{ getJoinType(scope.row) }}</span>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    name: 'ChatGroup',
    props: {
        group_info: {
            type: Array
        }
    },
    data() {
        return {
            groupInfo: []
        }
    },
    methods: {
        getJoinType(row) {
            let str = ''
            if (row.join_scene < 3) {
                str = '由 ' + (row.employee ? row.employee.name : '成员') + ' 邀请入群'
            } else {
                str = '通过扫描群二维码入群'
            }

            return str
        },
        execBind (chat_id) {
            this.$emit('doRealBind',{chat_id:chat_id})
        }
    },
    watch: {
        group_info: {
            handler(n) {
                this.groupInfo = []
                if (n.length > 0) {
                    this.groupInfo = this.group_info[0]
                }
            },
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/common/ChatGroup.vue